import { Injector } from '@angular/core';
import { LiveVariable } from '@wavemaker/variables';
import { WmsLiveVariableService } from '@wms/variables';
import {ProjectService} from "@wms/services";

export class WmsLiveVariable extends LiveVariable {
  liveVariableService: WmsLiveVariableService;
  projectService: ProjectService;

  constructor(variable: any, private inject: Injector) {
    super(variable);
    this.projectService = this.inject.get(ProjectService);
    this.liveVariableService = this.inject.get(WmsLiveVariableService);
  }

  override invoke(options?:any, success?:any, error?:any): Promise<any> {
    options = options || {};
    options.skipDataSetUpdate = true;
    return super.invoke(options, success, error);
  }

  override execute(methodName: string, options?:any): Promise<any> {
    options = options || {};
    if (methodName === 'getAggregatedData' && !this.projectService.getDeployedUrl()) {
      return this.projectService.getAppRunURL(false).then(() => {
        return super.execute(methodName, options);
      });
    }
    return super.execute(methodName, options);
  }

  __getTableMetaData(projectID: any, variable: any, writableVariable: any, options: any, callback: any, success: any) {
    return this.liveVariableService.__getTableMetaData(projectID, variable, writableVariable, options, callback, success);
  }

  __setVariableProp(variable: any, writableVariable: any, propertyName: any, propertyValue: any) {
    return this.liveVariableService.__setVariableProp(variable, writableVariable, propertyName, propertyValue);
  }

  __updateVariableDataset(variable: any, data: any, propertiesMap: any, pagingOptions: any) {
    return this.liveVariableService.__updateVariableDataset(variable, data, propertiesMap, pagingOptions);
  }

  __getVariableDependencies() {
    return this.liveVariableService.__getVariableDependencies();
  }

  __onPropertyChange(propertyName: string, value?: any, initFlag?: any) {
    return this.liveVariableService.__onPropertyChange(propertyName, value, initFlag);
  }

  __update(variable: any, varInstance: any, options?: any) {
    return this.liveVariableService.__update(variable, varInstance, options);
  }

  __onMaxResultsChange() {
    return this.liveVariableService.__onMaxResultsChange();
  }

  __onOperationChange(initFlag: any) {
    return this.liveVariableService.__onOperationChange(initFlag);
  }

  __onTypeChange(initFlag: any) {
    return this.liveVariableService.__onTypeChange(initFlag);
  }

  __addOneToManyRelatedFieldNodes(response: any, operation: any, selectedVariable: any) {
    return this.liveVariableService.__addOneToManyRelatedFieldNodes(response, operation, selectedVariable);
  }

  __isValidColumn(operation: any, primaryKeys: any, column: any) {
    return this.liveVariableService.__isValidColumn(operation, primaryKeys, column);
  }

  __isSystemDefined(colValue: any) {
    return this.liveVariableService.__isSystemDefined(colValue);
  }


  __resetOrderByProp(propertyObject: any) {
    return this.liveVariableService.__resetOrderByProp(propertyObject);
  }

  __onLiveSourceChange(initFlag: any) {
    return this.liveVariableService.__onLiveSourceChange(initFlag);
  }
}
